export function foldPl(text) {
    if (!text) return '';

    var mapChars = {
        'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
        'Ą': 'a', 'Ć': 'c', 'Ę': 'e', 'Ł': 'l', 'Ń': 'n', 'Ó': 'o', 'Ś': 's', 'Ź': 'z', 'Ż': 'z'
    };

    return String(text)
        .replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, function(ch) {
            return mapChars[ch] || ch;
        })
        .toLowerCase();
}

export function toAsciiSlug(str) {
    return foldPl(str).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}